// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__FYgJP","large":"styles_large__Xt9GV"};